import { render } from "./CreditRequest.vue?vue&type=template&id=2b485311&scoped=true"
import script from "./CreditRequest.vue?vue&type=script&lang=js"
export * from "./CreditRequest.vue?vue&type=script&lang=js"

import "./CreditRequest.vue?vue&type=style&index=0&id=2b485311&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b485311"]])

export default __exports__